
<template>
  <div class="kui-telinput" :class='{"direction": !options.isVertical}' :ref='options.field'>
    <span v-show="options.title" class="kui-telinput-title"
      :class="{'required-must':options.required}">{{titleName}}</span>
    <div class="telinput-wrap">
      <kui-combobox ref='TEL_QUHAO'
        :options="{width: 80,required:options.required, value: '086+',textField: 'dict_des',data:[{dict_val: '086+', dict_des: '086+'}],disabled: options.disabled}">
      </kui-combobox>
      <kui-textinput ref='AREA_CODE' :options="{width: 70,required:options.required, disabled: options.disabled}">
      </kui-textinput>
      <span class='middle-separator'>-</span>
      <kui-textinput ref='TEL_CODE'
        :options="{width: telCodewidth, required:options.required, disabled: options.disabled}"></kui-textinput>
    </div>
  </div>
</template>
<script>
import telinput from "./src/telinput";
export default telinput;
</script>
<style lang='less' scoped>
.kui-telinput {
  display: flex;
  align-items: center;
  padding: 8px;
  &.direction {
    display: inline-flex;
  }
  .kui-telinput-title {
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #343434;
    padding: 0 5px 0 0;
    box-sizing: border-box;
    position: relative;
  }
  .kui-telinput-title.required-must:before {
    content: "*";
    color: #f56c6c;
    display: inline-block;
    position: absolute;
    line-height: 110%;
    left: -10px;
  }
  .telinput-wrap {
    display: flex;
    align-items: center;
    .kui-combobox {
      padding: 0px 4px 0px 0px;
    }
    .kui-textinput {
      padding: 0px;
    }
  }
  .middle-separator {
    color: #343434;
    margin: 0 2px;
  }
}
</style>





// WEBPACK FOOTER //
// src/lib/ui/default/telinput/index.vue